export default {
  _execCallbacks(event) {
    const callbacks = this.callbacks ? this.callbacks[event] : null;
    const args = $.makeArray(arguments);
    args.shift();
    args.push(this.$component); // Always put jQuery element as last param

    this._execJQueryCallbacks(event, args);

    if (callbacks && callbacks.length > 0)
      for (let i = 0; i < callbacks.length; i++) {
        callbacks[i](...args);
      }
  },

  _execJQueryCallbacks(event, params) {
    this.$component.trigger(event, ...params);
  },

  on(event, callback) {
    this.callbacks = this.callbacks || {};
    this.callbacks[event] = this.callbacks[event] || [];

    if (typeof callback === 'function')
      this.callbacks[event].push(callback);
  },

  close() {
    this.$component.removeClass('open');
    $('.dropdown-menu', this.$component).trigger('hide.bs.dropdown');

    this._execCallbacks('close');
  },

  refresh(trigger = true) {
    const data = this._getPage(this.currentPage).data;
    this.renderOptions(data, true, trigger);
    this._execCallbacks('refresh');
  },

  enable() {
    this.$component.data('disabled', false);
    this.loadConfig();
    $('.dropdown-toggle', this.$component).removeAttr('disabled');

    this._execCallbacks('enable');
  },

  disable() {
    this.$component.data('disabled', true);
    this.loadConfig();
    $('.dropdown-toggle', this.$component).attr('disabled', true);

    this._execCallbacks('disable');
  },

  reset(clear = true) {
    this.currentPage = 1;
    this.filteredOptions = [];
    this.renderedValues = [];

    if (clear) {
      this.selectedValues = [];
      $('input[type="checkbox"], input[type="radio"]', this.$component)
        .prop('checked', false)
        .trigger('change');
    } else {
      if (this.selectedValues) {
        this.selectedValues = this.filterValues(this.selectedValues);
      } else {
        this.selectedValues = [];
      }
    }

    this.renderOptions(this._getPage(1).data, true, false);

    // Ajax
    if (!this.ajax) return;
    this.isDataFetched = false;
    this.$ajaxData = $('.js-ajax-data', this.$component);
  },

  setValue(value) {
    if (!this.ajax) return;
    const val = (Array.isArray(value) ? value : [value]).map(x => x.toString());

    if (this.isDataFetched) {
      this.selectedValues = this.filterValues(val);
      this.refresh(false);
      this._execCallbacks('change', this.selectedValues);
    } else {
      this.fetch(null, val);
    }
  },

  getValue(cb = null) {
    const value = this.multiple ?
      this.selectedValues.length ? this.selectedValues : [this.config.value] :
      this.config.value;

    if (cb && typeof cb === 'function')
      cb(value);
    else
      return value;
  },

  setConfig(config) {
    const component = this.$component.get(0);

    $(Object.keys(config)).each((i, key) => {
      component.dataset[key] = config[key];
    });

    this.$component.data(config);
    this.loadConfig();
  },

  getConfig(cb) {
    if (cb && typeof cb === 'function')
      cb(this.config);
    else
      return this.config;
  },

  setFormatFunction(func) {
    this.formatFunction = func;
  },

  setOptionRenderingFunction(func) {
    this.optionRenderingFunction = func;
  }
};
